import React, {useContext} from "react";
import {Button} from "@material-ui/core/index";

import Box from "@material-ui/core/Box/index";

import Isamslogo from "../assets/Isamslogo";
import {IsamsContext} from "./IsamsContext";


export default function IsamsButton(props) {

    const context = useContext(IsamsContext);
    const {failCallBack} = props;

    const loginWithIsams = () =>{
        try {
            const isamsRedirect = `${context.accessData.authority}auth/connect/authorize?client_id=${context.accessData.clientId}&redirect_uri=${encodeURIComponent(context.accessData.redirectUri)}&response_type=${encodeURIComponent(context.accessData.responseType)}&scope=${context.accessData.scope}&state=${context.accessData.state}&nonce=${context.accessData.nonce}&display=popup`;
            window.open(isamsRedirect, "", "width=600,height=600");

            window.addEventListener('storage', () => {
                const auth = localStorage.getItem('redux-authDal');
                const isamsFail = localStorage.getItem('isamsFail');
                if(auth){
                    const authObject = JSON.parse(auth)
                    if(authObject.isAuthenticated === 'true'){
                         window.location.reload();
                    }
                }
                if(isamsFail){
                    // console.log(isamsFail);
                    localStorage.removeItem('isamsFail');
                    failCallBack(true);
                }
            });


        }
        catch(e){
            console.warn(e);
        }

    };

    return (

            <Box>
                <Button
                    fullWidth
                    size="large"
                    color="inherit"
                    variant="outlined"
                    disabled={context.isLoading}
                    onClick={loginWithIsams}
                >
                    <Isamslogo
                        sx={{
                            width:100,
                            marginTop:1
                        }}
                    />
                </Button>
            </Box>

    );

}